import { UI, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Button, Center } from 'native-base';
import React from 'react';

import { BasketLink } from '../BasketLink';

export interface OrderHeaderDetailsProps {
  isMobile?: boolean;
  orderName: string;
  lastUpdateDate: string;
  isBasket: boolean;
  orderHasBasket: boolean;
  onBasketPress?: () => void;
  onExportPress?: () => void;
  onClose: () => void;
}

export const OrderHeaderDetails: React.FC<OrderHeaderDetailsProps> = ({
  isMobile,
  isBasket,
  orderHasBasket,
  orderName,
  lastUpdateDate,
  onClose,
  onExportPress,
  onBasketPress,
}) => {
  const title = isBasket ? 'cesta' : 'ordem';

  if (isMobile) {
    return (
      <Button
        p={0}
        size={'lg'}
        variant="textLink"
        leftIcon={<UI.Icon name="ArrowLeft" size="xxs" color={Color['neutral.black']} />}
        onPress={onClose}
        justifyContent="start"
        _text={{
          color: Color['neutral.black'],
          textTransform: 'capitalize',
          pl: Spacing['inline.nano'],
          fontSize: Typography['fontsize.lg'],
        }}>
        {`${title} ${orderName}`}
      </Button>
    );
  }

  return (
    <HStack w="full" justifyContent="space-between" mb={Spacing['stack.xxxs']}>
      <VStack space={Spacing['stack.nano']}>
        <HStack space={Spacing['inline.nano']} alignItems="center">
          <UI.Text color="neutral.black" fontSize={Typography['fontsize.lg']} variant="semibold">
            Detalhes da {title} {orderName}
          </UI.Text>
          {orderHasBasket && <BasketLink onPress={onBasketPress} />}
        </HStack>
        <HStack space={Spacing['inline.nano']}>
          <UI.Text variant="semibold" color="neutral.medium">
            Ultima atualização:
          </UI.Text>
          <UI.Text color="neutral.darkest">{lastUpdateDate}</UI.Text>
        </HStack>
      </VStack>
      <HStack space={Spacing['inline.xxxs']}>
        <Button
          p={0}
          variant="textLink"
          size="lg"
          disabled={!onExportPress}
          isDisabled={!onExportPress}
          onPress={onExportPress}
          leftIcon={<UI.Icon name="Pdf" size="xxs" color={Color['brand.tertiary.principal']} />}>
          EXPORTAR
        </Button>
        <Center>
          <UI.IconButton
            testId="close-modal"
            p={0}
            icon="CloseModal"
            iconSize="xxs"
            borderWidth="1px"
            borderColor={Color['brand.primary.principal']}
            iconColor={Color['brand.primary.principal']}
            onPress={onClose}
          />
        </Center>
      </HStack>
    </HStack>
  );
};
